// const view = name => (resolve) => {
//     require([`@/views/${name}/index.vue`], resolve); // eslint-disable-line
// };
import viewNames from '../views/constant'
const view = name => () => import(`@/views/${name}/index.vue`)
const viewRename = async pathName => {
    let pathNameArr = pathName.split('/')
    let str = pathNameArr.reduce((pre, current) => pre + '/' + current, '')
    return import(`@/views${str}.vue`)
}
const pageNotFound = view('pageNotFound')
const home = view('home')
const login = view('login')
const goodsDetail = () => viewRename('goodsDetail/goodsDetail')
const moreSstoreGoodsDetail = () => viewRename('goodsDetail/moreSstoreGoodsDetail')
const distributionDetail = () => viewRename('goodsDetail/distributionDetail')
const distributionStoreList = view('distributionStoreList')
const confirmOrder = view('confirmOrder')
const editOrderInfo = view('editOrderInfo')
const editAddress = view('editAddress')
const chooseToPay = view('chooseToPay')
const payResult = view('payResult')
const user = view('user')
const photoReports = view('photoReports')
const bindingPhone = view('bindingPhone')
const bindingResult = view('bindingResult')
const specialActivity = view('specialActivity')
const marketingDetail = view('marketingDetail')
const storeList = view('storeList')
const goodsList = view('goodsList')
const seckill = view('seckill')
const seckillStoreList = view('seckillStoreList')
const distributionActivity = view('distributionActivity')
const appDownload = view('appDownload')
const advice = view('advice')
const changeGoods = () => viewRename('advice/changeGoods')
const selectService = () => viewRename('advice/selectService')
const serviceDetail = view('serviceDetail')
const mergeSpread = view('mergeSpread')
const mergeSpreadStoreList = view('mergeSpreadStoreList')
const activityPayResult = view('activityPayResult')
const marketingActivities = view('marketingActivities')
const marketingConfirmOrder = view('marketingConfirmOrder')
const discountService = view('discountService')
const recommendStoreList = view('recommendStoreList')
const storeHome = view('storeHome')
const distributorMall = view('distributorMall')
const distributionList = view('distributionList')
const goodsClassification = view('goodsClassification')
const carBrandSelect = view('carBrandSelect')
const carLineSelect = view('carLineSelect')
const carModelSelect = view('carModelSelect')
const customDetail = view('customDetail')
const customSingularDetail = view('customSingularDetail')
const customGoodsList = view('customGoodsList')
const customSingularGoodsList = view('customSingularGoodsList')
const regularCustomDetail = view('regularCustomDetail')
const paction = view('paction')
const selectAddress = view('selectAddress')
const selectCityList = view('selectCityList')
const couponDetail = view('couponDetail')
const couponStoreList = view('couponStoreList')
const userCoupon = view('userCoupon')
const aggregation = view('aggregation')
const aggregationSearch = view('aggregationSearch')
const customSingularStoreList = view('customSingularStoreList')

export default [{
    path: '*',
    name: 'pageNotFound',
    componentName: viewNames.pageNotFound,
    meta: {
        title: '提示',
        keepAlive: false
    },
    component: pageNotFound
},
{
    path: '/',
    name: 'home',
    componentName: viewNames.home,
    meta: {
        title: '首页',
        keepAlive: false
    },
    component: home
},
{
    path: '/login',
    name: 'login',
    componentName: viewNames.login,
    meta: {
        title: '登录',
        keepAlive: true
    },
    component: login
},
{
    path: '/goodsDetail',
    name: 'goodsDetail',
    componentName: viewNames.goodsDetail,
    meta: {
        title: '商品详情',
        keepAlive: false
    },
    component: goodsDetail
},
{
    path: '/distributionDetail',
    name: 'distributionDetail',
    componentName: viewNames.distributionDetail,
    meta: {
        title: '商品详情',
        keepAlive: true
    },
    component: distributionDetail
},
{
    path: '/confirmOrder',
    name: 'confirmOrder',
    componentName: viewNames.confirmOrder,
    meta: {
        title: '确认订单',
        keepAlive: false
    },
    component: confirmOrder
},
{
    path: '/editOrderInfo',
    name: 'editOrderInfo',
    componentName: viewNames.editOrderInfo,
    meta: {
        title: '编辑收货信息',
        keepAlive: true
    },
    component: editOrderInfo
},
{
    path: '/editAddress',
    name: 'editAddress',
    componentName: viewNames.editAddress,
    meta: {
        title: '新增/编辑收货地址',
        keepAlive: false
    },
    component: editAddress
},
{
    path: '/chooseToPay',
    name: 'chooseToPay',
    componentName: viewNames.chooseToPay,
    meta: {
        title: '选择支付',
        keepAlive: false
    },
    component: chooseToPay
},
{
    path: '/payResult',
    name: 'payResult',
    componentName: viewNames.payResult,
    meta: {
        title: '交易完成',
        keepAlive: true
    },
    component: payResult
},
{
    path: '/user/',
    name: 'user',
    componentName: viewNames.user,
    meta: {
        title: '我的',
        keepAlive: false
    },
    component: user
},
{
    path: '/photoReports',
    name: 'photoReports',
    componentName: viewNames.photoReports,
    meta: {
        title: '图集',
        keepAlive: false
    },
    component: photoReports
},
{
    path: '/bindingPhone',
    name: 'bindingPhone',
    componentName: viewNames.bindingPhone,
    meta: {
        title: '绑定手机号码',
        keepAlive: false
    },
    component: bindingPhone
},
{
    path: '/bindingResult',
    name: 'bindingResult',
    componentName: viewNames.bindingResult,
    meta: {
        title: '绑定手机号码',
        keepAlive: false
    },
    component: bindingResult
},
{
    path: '/specialActivity',
    name: 'specialActivity',
    componentName: viewNames.specialActivity,
    meta: {
        title: '',
        keepAlive: true
    },
    component: specialActivity
},
{
    path: '/marketingDetail',
    name: 'marketingDetail',
    componentName: viewNames.marketingDetail,
    meta: {
        title: '枫车推广',
        keepAlive: true
    },
    component: marketingDetail
},
{
    path: '/storeList',
    name: 'storeList',
    componentName: viewNames.storeList,
    meta: {
        title: '活动周边门店',
        keepAlive: false
    },
    component: storeList
},
{
    path: '/goodsList',
    name: 'goodsList',
    componentName: viewNames.goodsList,
    meta: {
        title: '商品列表',
        keepAlive: false
    },
    component: goodsList
},
{
    path: '/seckill',
    name: 'seckill',
    componentName: viewNames.seckill,
    meta: {
        title: '整点大秒杀',
        keepAlive: false
    },
    component: seckill
},
{
    path: '/seckillStoreList',
    name: 'seckillStoreList',
    componentName: viewNames.seckillStoreList,
    meta: {
        title: '选择门店',
        keepAlive: false
    },
    component: seckillStoreList
},
{
    path: '/distributionActivity',
    name: 'distributionActivity',
    componentName: viewNames.distributionActivity,
    meta: {
        title: '分销活动页',
        keepAlive: false
    },
    component: distributionActivity
},
{
    path: '/appDownload',
    name: 'appDownload',
    componentName: viewNames.appDownload,
    meta: {
        title: '枫车养车',
        keepAlive: false
    },
    component: appDownload
},
{
    path: '/distributionStoreList',
    name: 'distributionStoreList',
    componentName: viewNames.distributionStoreList,
    meta: {
        title: '选择门店',
        keepAlive: false
    },
    component: distributionStoreList
},
{
    path: '/advice',
    name: 'advice',
    componentName: viewNames.advice,
    meta: {
        title: '保养建议',
        keepAlive: true
    },
    component: advice
},
{
    path: '/changeGoods',
    name: 'changeGoods',
    componentName: viewNames.changeGoods,
    meta: {
        title: '更改商品',
        keepAlive: false
    },
    component: changeGoods
},
{
    path: '/selectService',
    name: 'selectService',
    componentName: viewNames.selectService,
    meta: {
        title: '选择服务',
        keepAlive: true
    },
    component: selectService
},
{
    path: '/serviceDetail',
    name: 'serviceDetail',
    componentName: viewNames.serviceDetail,
    meta: {
        title: '服务详情',
        keepAlive: false
    },
    component: serviceDetail
},
{
    path: '/mergeSpread',
    name: 'mergeSpread',
    componentName: viewNames.mergeSpread,
    meta: {
        title: '聚合推广',
        keepAlive: true,
    },
    component: mergeSpread
},
{
    path: '/mergeSpreadStoreList',
    name: 'mergeSpreadStoreList',
    componentName: viewNames.mergeSpreadStoreList,
    meta: {
        title: '选择门店',
        keepAlive: false
    },
    component: mergeSpreadStoreList
},
{
    path: '/activityPayResult',
    name: 'activityPayResult',
    componentName: viewNames.activityPayResult,
    meta: {
        title: '交易成功',
        keepAlive: false
    },
    component: activityPayResult
},
{
    path: '/marketingActivities',
    name: 'marketingActivities',
    componentName: viewNames.marketingActivities,
    meta: {
        title: '营销活动详情',
        keepAlive: true
    },
    component: marketingActivities
},
{
    path: '/marketingConfirmOrder',
    name: 'marketingConfirmOrder',
    componentName: viewNames.marketingConfirmOrder,
    meta: {
        title: '订单确认',
        keepAlive: true
    },
    component: marketingConfirmOrder
},
{
    path: '/discountService',
    name: 'discountService',
    componentName: viewNames.discountService,
    meta: {
        title: '特惠服务',
        keepAlive: false
    },
    component: discountService
},
{
    path: '/recommendStoreList',
    name: 'recommendStoreList',
    componentName: viewNames.recommendStoreList,
    meta: {
        title: '推荐门店列表',
        keepAlive: false
    },
    component: recommendStoreList
},
{
    path: '/storeHome',
    name: 'storeHome',
    componentName: viewNames.storeHome,
    meta: {
        title: '门店主页',
        keepAlive: false
    },
    component: storeHome
},
{
    path: '/distributorMall',
    name: 'distributorMall',
    componentName: viewNames.distributorMall,
    meta: {
        title: '商城主页',
        keepAlive: false
    },
    component: distributorMall
},
{
    path: '/distributionList',
    name: 'distributionList',
    componentName: viewNames.distributionList,
    meta: {
        title: '商品列表',
        keepAlive: false
    },
    component: distributionList
},
{
    path: '/goodsClassification',
    name: 'goodsClassification',
    componentName: viewNames.goodsClassification,
    meta: {
        title: '商品分类',
        keepAlive: false
    },
    component: goodsClassification
},
{
    path: '/carBrandSelect',
    name: 'carBrandSelect',
    componentName: viewNames.carBrandSelect,
    meta: {
        title: '选择车品牌',
        keepAlive: false
    },
    component: carBrandSelect
},
{
    path: '/carLineSelect',
    name: 'carLineSelect',
    componentName: viewNames.carLineSelect,
    meta: {
        title: '选择车系',
        keepAlive: false
    },
    component: carLineSelect
},
{
    path: '/carModelSelect',
    name: 'carModelSelect',
    componentName: viewNames.carModelSelect,
    meta: {
        title: '选择车型',
        keepAlive: false
    },
    component: carModelSelect
},
{
    path: '/customDetail',
    name: 'customDetail',
    componentName: viewNames.customDetail,
    meta: {
        title: '自定义推广详情', // 多店
        keepAlive: true
    },
    component: customDetail
},
{
    path: '/customSingularDetail',
    name: 'customSingularDetail',
    componentName: viewNames.customSingularDetail,
    meta: {
        title: '自定义推广详情', // 单店
        keepAlive: true
    },
    component: customSingularDetail
},
{
    path: '/customGoodsList',
    name: 'customGoodsList',
    componentName: viewNames.customGoodsList,
    meta: {
        title: '商品列表', // 多店
        keepAlive: false
    },
    component: customGoodsList
},
{
    path: '/customSingularGoodsList',
    name: 'customSingularGoodsList',
    componentName: viewNames.customSingularGoodsList,
    meta: {
        title: '商品列表', // 单店
        keepAlive: false
    },
    component: customSingularGoodsList
},
{
    path: '/regularCustomDetail',
    name: 'regularCustomDetail',
    componentName: viewNames.regularCustomDetail,
    meta: {
        title: '商家常规推广',
        keepAlive: true
    },
    component: regularCustomDetail
},
{
    path: '/paction',
    name: 'paction',
    componentName: viewNames.paction,
    meta: {
        title: '用户协议', // 用户协议或者隐私政策
        keepAlive: false
    },
    component: paction
},
{
    path: '/selectAddress',
    name: 'selectAddress',
    componentName: viewNames.selectAddress,
    meta: {
        title: '选择地址',
        keepAlive: false
    },
    component: selectAddress
},
{
    path: '/selectCityList',
    name: 'selectCityList',
    componentName: viewNames.selectCityList,
    meta: {
        title: '选择城市',
        keepAlive: false
    },
    component: selectCityList
},
{
    path: '/moreSstoreGoodsDetail',
    name: 'moreSstoreGoodsDetail',
    componentName: viewNames.moreSstoreGoodsDetail,
    meta: {
        title: '商品详情',
        keepAlive: false
    },
    component: moreSstoreGoodsDetail
},
{
    path: '/couponDetail',
    name: 'couponDetail',
    componentName: viewNames.couponDetail,
    meta: {
        title: '优惠券',
        keepAlive: false
    },
    component: couponDetail
},
{
    path: '/couponStoreList',
    name: 'couponStoreList',
    componentName: viewNames.couponStoreList,
    meta: {
        title: '可用券门店',
        keepAlive: false
    },
    component: couponStoreList
},
{
    path: '/userCoupon',
    name: 'userCoupon',
    componentName: viewNames.userCoupon,
    meta: {
        title: '可用优惠券',
        keepAlive: false
    },
    component: userCoupon
},
{
    path: '/aggregation',
    name: 'aggregation',
    componentName: viewNames.aggregation,
    meta: {
        title: '商品聚合',
        keepAlive: false
    },
    component: aggregation
},
{
    path: '/aggregationSearch',
    name: 'aggregationSearch',
    componentName: viewNames.aggregationSearch,
    meta: {
        title: '搜索',
        keepAlive: false
    },
    component: aggregationSearch
},
{
    path: '/customSingularStoreList',
    name: 'customSingularStoreList',
    componentName: viewNames.customSingularStoreList,
    meta: {
        title: '周边门店',
        keepAlive: false
    },
    component: customSingularStoreList
},
]
